<div class="container">
    <span class="title">{{ 'reward-unlocked-title' | translate}}</span>
    <div class="imageRewardContainer">
        <img *ngIf="imageToWinUrl!==''" [attr.src]="imageToWinUrl" alt=""/>
    </div>
    <span class="title">{{itemToWinLabel}}</span>
    <button *ngIf="ready" (click)="next()">{{'generic.next'|translate}}</button>
</div>
